import type { Product } from "../../types";
import { doorAccessReadersIntercom } from "../product-list-groups/doorAccessReadersIntercom";
import { uaUltra } from "./uaUltra";

export const readerAccessUltra: Product = {
  ...uaUltra,
  productListGroup: doorAccessReadersIntercom,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '126 x 45 x 37.45 mm\n(4.9 x 1.8 x 4.5")',
      },
    },
    {
      propertyId: "cameraReader",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "twoWayIntercom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "directory",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "touchPassSupport",
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: "pinAccess",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "nfcCard",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "mobileAppAccess",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "hand",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "outdoorReady",
      value: {
        type: "translation",
        value: "uaUltra.outdoorReady",
      },
    },
    {
      propertyId: "readerPowerMethod",
      value: {
        type: "string",
        value: "PoE+",
      },
    },
  ],
};
